import { Dispatch } from 'react';
import { IAction } from 'appRedux/reducers';
import { IHotColdCollapsedState } from 'appRedux/models/slotModels';
import { SectionIdType } from 'appRedux/reducers/slotReducer';

const slotReduxKey = 'SLOT';

export const slotActionTypes = {
  SET_DEFAULT_SECTION: `${slotReduxKey}-SET_DEFAULT_SECTION`,
  MOVE_SECTION: `${slotReduxKey}-MOVE_SECTION`,
  TOGGLE_HOT_COLD_COLLAPSED: `${slotReduxKey}-TOGGLE_HOT_COLD_COLLAPSED`,
  SET_SELECTED_SLOTS_NAME: `${slotReduxKey}-SET_SELECTED_SLOTS_NAME`,
  SET_SELECTED_SLOTS: `${slotReduxKey}-SET_SELECTED_SLOTS`,
  CLEAR_SELECTED_SLOTS: `${slotReduxKey}-CLEAR_SELECTED_SLOTS`,
  SET_SELECTED_BANK_FILTER: `${slotReduxKey}-SET_SELECTED_BANK_FILTER`,
  SET_SEARCH_MODE: `${slotReduxKey}-SET_SEARCH_MODE`,
  SET_CHALLENGE_EGM_PIN_CONFIG: `${slotReduxKey}-SET_CHALLENGE_EGM_PIN_CONFIG`,
  SET_CHALLENGE_HEADER_BG_URL: `${slotReduxKey}-SET_CHALLENGE_HEADER_BG_URL`,
  SET_CHALLENGE_NAME: `${slotReduxKey}-SET_CHALLENGE_NAME`,
  SET_CHALLENGE_PIN_DETAILS: `${slotReduxKey}-SET_CHALLENGE_PIN_DETAILS`,
};

export const SlotReduxCommandCreator = (dispatch: Dispatch<IAction>) => {
  return {
    SetDefaultSection(state: { sectionId: SectionIdType }) {
      dispatch({
        type: slotActionTypes.SET_DEFAULT_SECTION,
        state,
      });
    },
    MoveSection(state: { sectionId: string; newPosition: number; sections: string[] }) {
      dispatch({
        type: slotActionTypes.MOVE_SECTION,
        state,
      });
    },
    ToggleHotColdCollapsed(state: IHotColdCollapsedState) {
      dispatch({
        type: slotActionTypes.TOGGLE_HOT_COLD_COLLAPSED,
        state,
      });
    },
    SelectedSlotsName(slotName: string) {
      dispatch({
        type: slotActionTypes.SET_SELECTED_SLOTS_NAME,
        state: slotName,
      });
    },
    SelectBankFilter(bankFilter: boolean){
      dispatch({
        type: slotActionTypes.SET_SELECTED_BANK_FILTER,
        state: bankFilter,
      });
    },
    SetSearchMode(isSearchMode: boolean) {
      dispatch({
        type: slotActionTypes.SET_SEARCH_MODE,
        state: isSearchMode,
      });
    },
    SelectedSlots(selectedSlots: string[]) {
      dispatch({
        type: slotActionTypes.SET_SELECTED_SLOTS,
        state: selectedSlots,
      });
    },
    ClearSelectedSlots() {
      dispatch({
        type: slotActionTypes.CLEAR_SELECTED_SLOTS,
      });
    },
    SetChallengeEGMPinConfig(config: Record<string, { pinDisplayType: string; pinDisplayCode: string }> | null) {
      dispatch({
        type: slotActionTypes.SET_CHALLENGE_EGM_PIN_CONFIG,
        state: config,
      });
    },
    SetChallengeHeaderBgUrl(url: string | null) {
      dispatch({
        type: slotActionTypes.SET_CHALLENGE_HEADER_BG_URL,
        state: url,
      });
    },
    SetChallengeName(name: string | null) {
      dispatch({
        type: slotActionTypes.SET_CHALLENGE_NAME,
        state: name,
      });
    },
    SetChallengePinDetails(details: {
      showInsightTopPins?: number | null;
      pinBackgroundColor?: string | null;
      pinNumberColor?: string | null;
    } | null) {
      dispatch({
        type: slotActionTypes.SET_CHALLENGE_PIN_DETAILS,
        state: details,
      });
    },
  };
};
